import type { FortressKit } from "../kit/types";

/**
 * The Moonstone Keep (8,000 Marks; contract tools/art/skins/README.md §Fortress). Owner: agent C. Its own model on all
 * three tiers like the Dragonlord (`art/hq/base_t<1-3>__moonstone.glb`, built by tools/art/skins/moonstone_fortress.py):
 * pale moonstone ashlar and silver with midnight roofs; a cratered moon floating over the keep that slowly turns and
 * breathes (it is the strike conductor's tip, `condgem0`: the bolt leaves the moon), a silver ring of star beads and four
 * moonstone shards circling it, silver crescents on every spire, midnight banners sewn with silver stars, moonfire
 * torches and silver-blue windows. Clips build / idle / charge / fire + `show`: a moonrise at level start.
 * Fortress v2 (2026-10-19): rebuilt on the new fortress (art/fortress/skin_moonstone.py); two moon owls circle the moon
 * (`art/hq/fortress_owl__moonstone.glb`, views/fortressCompanion.ts) and shafts of moonlight fall on the courtyard
 * (views/fortressAmbience.ts). In a level: pale motes drift off the moon, the strike is cold silver-blue, and the reveal ends in a moonrise flare.
 */
export const MOONSTONE: FortressKit = {
  id: "fortress.moonstone",
  model: "moonstone",
  idle: { kind: "motes", colour: 0xd6e8ff, every: [1.5, 2.8], count: 5, radius: 0.32, node: "condgem0" },
  strike: { core: [1, 1, 1], rim: [0.62, 0.8, 1], hex: 0x9cc8ff, coreHex: 0xeef6ff },
  reveal: "moonrise",
  // fortress v2 (2026-10-19): two moon owls circle the moon (scaled to read at phone distance: a 0.7 wingspan), and moonbeams fall on the courtyard
  companion: {
    model: "fortress_owl__moonstone", count: 2, scale: 1.7, around: "tip",
    radius: 1.25, squash: 1, ahead: 0.35, height: 0.55, bob: 0.18, dip: 0, bank: 0.6, lap: 7, clear: 0.12,
    clips: { fly: "fly", glide: "glide", roar: "swoop" },
    // 2026-10-20 (owner: "the owls are flying into the building"): the loop rides over the moon (height 0.55 above it, ahead 0.8 → 0.35 so the near pass keeps ~0.9 off the moon and its rings,
    // clear of the keep's top by 0.12 everywhere), so no pass crosses the spire, the hall roof or the moon's arms.
    // client v2 (2026-10-20): the loop pulled toward the gate (still round the moon) so the owls stay in the default view
    // (on screen 66 % → 100 % of a lap, tools/video/companion_closeup.mjs); a brisker beat, gliding the descents, cross-faded
    gait: { cruiseHz: 1.4, beats: 1, climbGain: 0.5, glideBelow: -0.2, flapAbove: 0, hold: 0.7, fade: 0.35 },
    trail: { perSecond: 5, life: 0.9, colour: [0.82, 0.9, 1] },
    glow: [0.85, 0.92, 1],
  },
  ambience: { kind: "moonbeam", every: [3, 5], colour: [0.78, 0.88, 1], hex: 0xc8e0ff },
};
